import React from "react"
import {
  Box, ButtonGroup, IconButton, Text,
} from "@chakra-ui/react"
import Popover from "components/dialogs/Popover"
import Link from "components/elements/Link"
import { DioboxEvent } from "sharedTypes"
import { GUEST_PORTAL_HELP_ARTICLE_LINK } from "utilities/externalLinks"
import CopyToClipboard from "components/elements/CopyToClipboard"
import Button from "components/Buttons/Button"
import Icon from "components/elements/Icon"

type Props = {
  event: DioboxEvent

}

const SharePopover = ({ event }: Props) => {
  const guestPortalUrl = event.urls?.portal
  if (!guestPortalUrl) {
    return null
  }

  return (
    <ButtonGroup size="sm" isAttached variant="outline">
      <Button variant="outline" size="sm" leftIcon="link" onClick={() => window.open(guestPortalUrl, "_blank")}>Guest Portal</Button>
      <Popover
        contentWidth={275}
        placement="bottom-start"
        arrow={false}
        trigger={<IconButton colorScheme="button.primary" aria-label="Show Guest Portal links" icon={<Icon icon="down-arrow" />} />}
        wrapTrigger={false}
        body={(
          <>
            <Box p={6}>
              <Text fontWeight="semibold">Guest Portal URL</Text>
              <Link isExternal href={guestPortalUrl}>
                <Text fontWeight="bold" fontSize="lg">{guestPortalUrl}</Text>
              </Link>
              <CopyToClipboard text={guestPortalUrl} size="xs" variant="outline" mt={2}>Copy</CopyToClipboard>
            </Box>
            <Box px={6} py={3} borderTopWidth={1}>
              <Link isExternal href={GUEST_PORTAL_HELP_ARTICLE_LINK} color="black">
                <Text>Understanding the Guest Portal</Text>
              </Link>
            </Box>
          </>
        )}
      />

    </ButtonGroup>
  )
}

export default SharePopover
